import axios from "axios";
// import handleError from "./HandleError";
import API from "./APIService";
import BaseService from "./BaseService";

class SearchService extends BaseService {
    component = null;

    constructor(component) {
    	super(); 
    	this.component = component;
    }

    baseServicePath = () => API.url("search");
}

export default SearchService;


// WEBPACK FOOTER //
// ./src/services/SearchService.js